module.exports = __webpack_public_path__ + "img/slphouse_main3.dc138650.png";